import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import type { CtaBlock } from '../types';
import { RichSegments } from './RichSegments';
import styles from './Cta.module.css';
interface CtaProps {
  block: CtaBlock;
  blockId: string;
}
export function Cta(t0) {
  const $ = _c(15);
  const {
    block,
    blockId
  } = t0;
  const variantClass = block.variant === "secondary" ? styles.secondary : styles.primary;
  let t1;
  if ($[0] !== block.heading) {
    t1 = block.heading ? <p className={styles.heading}>{block.heading}</p> : null;
    $[0] = block.heading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== block.body) {
    t2 = block.body && block.body.length > 0 ? <p className={styles.body}><RichSegments segments={block.body} /></p> : null;
    $[2] = block.body;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${styles.button} ${variantClass}`;
  let t4;
  if ($[4] !== block.href || $[5] !== block.label || $[6] !== block.rel || $[7] !== block.target || $[8] !== t3) {
    t4 = <a href={block.href} target={block.target} rel={block.rel} className={t3}>{block.label}</a>;
    $[4] = block.href;
    $[5] = block.label;
    $[6] = block.rel;
    $[7] = block.target;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== blockId || $[11] !== t1 || $[12] !== t2 || $[13] !== t4) {
    t5 = <div className={styles.wrapper} data-cms-block-id={blockId} data-cms-field="cta">{t1}{t2}{t4}</div>;
    $[10] = blockId;
    $[11] = t1;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}